export var FinancialSituation;
(function (FinancialSituation) {
    FinancialSituation["ExtendedUnpaidLeave"] = "EXTENDED_UNPAID_LEAVE";
    FinancialSituation["IncreasedDebtRepaymentForExistingLoan"] = "INCREASED_DEBT_REPAYMENT_FOR_EXISTING_LOAN";
    FinancialSituation["LargeExpenditure"] = "LARGE_EXPENDITURE";
    FinancialSituation["MedicalTreatmentOrIllness"] = "MEDICAL_TREATMENT_OR_ILLNESS";
    FinancialSituation["None"] = "NONE";
    FinancialSituation["Other"] = "OTHER";
    FinancialSituation["PermanentDecreaseInIncome"] = "PERMANENT_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryDecreaseInIncome"] = "TEMPORARY_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryIncreaseInExpense"] = "TEMPORARY_INCREASE_IN_EXPENSE";
})(FinancialSituation || (FinancialSituation = {}));
//# sourceMappingURL=FinancialSituation.js.map